<template>
  <div class="comment">
    <div class="seach">
      <el-row>
        <div class="seach-list r iblock">
          <el-input
            placeholder="请输入搜索内容"
            v-model="search.keywords"
            round
            class="input-with-select input-sea r"
          >
            <el-button slot="append" icon="el-icon-search" @click="seachList()"></el-button>
          </el-input>
        </div>
      </el-row>
    </div>
    <!-- //表格数据 -->
    <div class="list-wrap" v-if="resultData.list&&resultData.list.length>=0" v-loading="tableLoading">
      <el-table
        ref="table"
        stripe
        :data="resultData.list"
        :header-cell-style="{backgroundColor:'#f5f7fa'}"
        style="width: 100%;margin: 20px 0;"
      >
          <el-table-column prop="course_name" label="课程名称"></el-table-column>
        <el-table-column prop="" label="课程讲师">
           <template slot-scope="scope">
             <span>{{scope.row.teachers | getTeacherName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="updated_at" label="直播时间"></el-table-column>
        <el-table-column prop="" label="状态">
          <template slot-scope="scope">
            <span v-show="scope.row.live_state==2">未开始</span>
            <span v-show="scope.row.live_state==1">正在直播</span>
            <span v-show="scope.row.live_state==3">已结束</span>
          </template>
        </el-table-column>
        <el-table-column prop="reward" label="打赏金额"></el-table-column>
        <el-table-column prop="reward_user_total" label="打赏人数"></el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
             <el-button type="text" size="mini" @click="payTeacher(scope.row)">支付给讲师</el-button>
             <el-button type="text" size="mini" @click="theDescript(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="tc">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="Number(search.page)"
          :page-size="Number(search.size)"
          layout="total, prev, pager, next"
          :total="Number(resultData.count)"
        ></el-pagination>
      </div>
        <!-- //支付给讲师的弹窗 -->
      <PayMoney 
       :respondVisible.sync="respondVisible"
       :resmessage="resmessage"
       @uploadInfo="uploadInfo"></PayMoney>
    </div>
  </div>
</template>

<script>
import qs from 'qs'

import {_commentList} from '@/api/user.js'

import {_getAllCourseList} from '@/api/course.js'

//导入mixins
import order_mixins from "./components/order-mixins"
//导入组件
import PayMoney from "./components/pay-money"

export default {
  created() {
    this.initCourseList();
    // console.log(this.payTeahcer)
  },
  mixins:[order_mixins],
  components:{
    PayMoney
  },
  //过滤器
  filters:{
    getTeacherName(value){
      let data=[];
      value.forEach(item=>{
        data.push(item.teacher_name)
      })
      return data.toString();
    }
  },
  data() {
    return {
      tableLoading:false,
       search: {
        page:1,
        size:10,
        keywords:'',
        status:"0"
        // course_id:'',//课程id
        // state:'',//状态
        // comment_mode:'',//类型,1:讲解;2:讨论;3问答
      },
      resultData: {
       
      }
    };
  },
  methods: {
    //查询信息
    seachList() {
      this.search.page=1;
      this.initCourseList();
    },
    //回复消息返回的状态
    uploadInfo(val){
      if(val){
        window.alert(1111);
        // this.initCommentsList();
      }
    },
    //翻页
    handleCurrentChange(val) {
      this.search.page = val
      this.initCourseList()
    },
      //加载课程列表
    initCourseList(){
      this.tableLoading=true;
      _getAllCourseList({
        params:{
          page:this.search.page,
          size:this.search.size,
          keywords:this.search.keywords,
          state:this.search.status,
          goods_mode:1
        }
      }).then(res=>{
        this.tableLoading=false;
        if(res.resultCode==1){
          this.resultData=res.result;
        }else{
          this.$message.error(res.errorMsg);
        }
      })
    },
    theDescript(row){
        let routeData = this.$router.resolve({
        path: `/payment/money-reward/descript/${row.course_id}`,
      });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>

<style scoped lang="less">
.seach {
  .seach-list {
    .input-v {
      // width: 160px;
      margin-left: 20px;
    }
    .input-sea {
      margin-left: 20px;
      width: 280px;
      border-radius: 5px;
    }
  }
}
.user-info {
  .guests-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    margin-right: 20px;
    vertical-align: middle;
  }
}
</style>